import BasicModal from "@/modules/common/components/modals/basic-modal";
import ModalHeader from "@/modules/common/components/modals/modal-header";
import { NwButton } from "@nawy/ui";
import { EnvironmentVariables } from "@/modules/common/types";
import Map from "@/modules/lead-page/components/lead-location/map";
import { leadLocationActionV2 } from "@/modules/lead-page/constants";
import { LeadLocationAction } from "@/modules/lead-page/types";
import { Box } from "@mui/material";
import { MouseEvent, useCallback, useState } from "react";

interface LocationActionsProps {
  latitude: number | null;
  longitude: number | null;
  id: number | null;
}

const LocationActions = ({ latitude, longitude, id }: LocationActionsProps) => {
  const [openMap, setOpenMap] = useState(false);

  const handleLocationClick = useCallback(() => {
    if (!openMap) setOpenMap(true);
  }, [openMap]);

  const handleCloseMap = useCallback(() => {
    if (openMap) setOpenMap(false);
  }, [openMap]);

  const isButtonDisabled = (label: string) => {
    if (label === "Location") {
      return !latitude || !longitude;
    } else if (label === "E-Realty") {
      return !id;
    } else {
      return true;
    }
  };

  const handleButtonClick = (
    _: MouseEvent<HTMLButtonElement>,
    label: string
  ) => {
    if (label === "Location") {
      return handleLocationClick();
    } else if (label === "E-Realty") {
      return window.open(
        `${EnvironmentVariables.EREALTY_URL}/project/${id}?use_nawy_id=true`,
        "_blank"
      );
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      {leadLocationActionV2.map((action: LeadLocationAction) => (
        <NwButton
          key={action.label}
          variant="text"
          startIcon={<action.icon />}
          disabled={isButtonDisabled(action.label)}
          sx={{
            ...action.customStyles,
            width: "fit-content",
            minWidth: "fit-content",
            paddingX: "0px",
          }}
          onClick={(e: MouseEvent<HTMLButtonElement>) =>
            handleButtonClick(e, action.label)
          }
        >
          {action.label}
        </NwButton>
      ))}

      {latitude && longitude && (
        <BasicModal
          open={openMap}
          setOpen={setOpenMap}
          width={800}
          height={500}
        >
          <ModalHeader headerText="Location" handleClose={handleCloseMap} />
          <Map
            center={[latitude, longitude]}
            zoom={12}
            maxZoom={15}
            minZoom={10}
            tileUrl="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </BasicModal>
      )}
    </Box>
  );
};

export default LocationActions;
